import MuiGrid, { Grid2Props } from "@mui/material/Unstable_Grid2";

type Props = Grid2Props;

export const Grid = ({ children, ...props }: Props) => {
  return <MuiGrid {...props}>{children}</MuiGrid>;
};
